export class IntegrationConnectionResult {
  constructor(private readonly _isSuccessful: boolean, private readonly reason: string | null) {}

  isSuccessful() {
    return this._isSuccessful;
  }

  getReason() {
    return this.reason;
  }
}
